import React, {Component} from 'react';
import {Button, Form, FormControl, FormGroup, InputGroup} from 'react-bootstrap';
import Select from 'react-select';

import InfiniteScroll from "react-infinite-scroll-component";
import DesignResourcesPanel from '../../components/designResourcesPanel';

const PageSize = 20;

const categorySelectionStyles = {

    option: (provided, state) => ({
        ...provided,
        textAlign: 'left',
        backgroundColor: state.isSelected ? '#C8CDD4' : (state.isFocused ? '#F1F2F3' : 'white'),
    }),

    menu: (provided, state) => ({
        ...provided,
        width: '275px'
    })
};


var default_drag_ghost = new window.Image();
default_drag_ghost.id = 'drag_image'
default_drag_ghost.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

class MockupPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 1,
            searchActive: false,
            searchKeywords: '',
            selectedCategory: {value: null, label: "All"},
            categories: [],
            fetchingDefaultCategory: false,
            defaultCategoryAlreadySet: false
        }
    }

    set_state = async state => new Promise(resolve => this.setState(state, resolve));


    handleCategoryChange = async (e, extra_options) => {

        let prevPage = this.state.page;

        let st = {
            selectedCategory: e,
            data: [],
            page: 1
        };

        if (extra_options) {
            for (let key in extra_options) {
                if (extra_options.hasOwnProperty(key)) {
                    st[key] = extra_options[key];
                }
            }
        }
        await this.set_state(st);
        if (prevPage <= 2) this.fetchData();
    };


    componentDidMount() {
        window.abcd = this

        fetch(global.config.server_path + 'category/get', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            'credentials': 'include',
            'body': JSON.stringify({'type': 'mockup'})
        })
        .then(resp => resp.json())
        .then(resp => {
            resp = resp.data;
            resp = resp.map(x => {
                return {label: x.name, value: x._id}
            });
            resp = resp.sort(function (a, b) {
                return (a.label < b.label) ? -1 : 1;
            });
            resp.unshift({"label": "All", value: null});

            fetch(global.config.server_path + 'mockup/get_mockups/', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                'credentials': 'include',
                body: JSON.stringify({
                    page_no: this.state.page,
                    size: PageSize,
                    active: true,
                    priority_sort: true
                })
            })
                .then(resp => resp.json())
                .then(resp => {
                    if (!this.state.fetchingDefaultCategory) {
                        let results = resp.data.map( x => ({ ...x, thumbnail: x.placeholders[0] || x.tracing_image_src }));
                        this.setState({
                            data: this.state.data.concat(results),
                            page: this.state.page + 1
                        })
                    }
                })
                .catch(error => Promise.reject(error))
            this.setState({categories: resp})
        })
        .catch(error => console.error(error))
    }

    handleSearchOnChange = (e) => {
        this.setState({
            searchKeywords: e.target.value
        });

        if (e.target.value === "") {
            this.handleSearchClear();
        }
    };

    fetchSearchResults = () => {

    	//IMPPP -> rename to mockups/_search
        let url = global.config.server_path + 'mockups/_search?';

        // let queryBody = {
        //     "from": ((this.state.page-1) * PageSize),
        //     "size": PageSize,
        //     "query": {
        //         "bool": {
        //             "must": {
        //                 "multi_match": {
        //                     "query": this.state.searchKeywords,
        //                     "fields": ["categories.name", "keywords", "name"],
        //                     "operator": "or",
        //                     "type": "best_fields"
        //                 }
        //             },
        //             "filter" : []
        //         }
        //     }
        // };

        // if (this.state.selectedCategory.value) {
        //     queryBody["query"]["bool"]["filter"].push({"terms": {"categories.name.keyword": [this.state.selectedCategory.label]}});
        // }

        // queryBody["query"]["bool"]["filter"].push({"term" : {"active": true}});

        let queryBody = {
            "from" : 0,
            "size" : 100,
            "query": {
              "multi_match" : {
                "query": this.state.searchKeywords,
                "fields": [ "name", "categories.name", "keywords"],
                "operator" : "or",
                "type" : "best_fields",
              }
            }
          }


        fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(queryBody)})
            .then(resp => resp.json())
            .then(resp => resp.hits.hits.map(x => x._id))
            .then(resp => {
                let url = global.config.server_path + 'mockup/get/';
                let payload = {
                    id: resp
                };
                if (this.state.selectedCategory.value) payload['category_id'] = this.state.selectedCategory.value;
                return fetch(url, {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    'credentials': 'include',
                    body: JSON.stringify(payload)
                });
            })
            .then(resp => resp.json())
            .then(resp => {
                let searchResults = resp.data.map( x => ({ ...x, thumbnail: x.placeholders[0] || x.tracing_image_src }));
                if (searchResults) {
                    this.setState({
                        data: this.state.data.concat(searchResults),
                        page: this.state.page + 1
                    })
                }
            })
            .catch(err => console.log(err))
    };


    fetchTemplates = () => {

    	console.log(this.state.selectedCategory);

        let payload = {
            page_no: this.state.page,
            size: PageSize,
            active : true,
            priority_sort: true
        };

        if (this.state.selectedCategory.value) payload['category_id'] = this.state.selectedCategory.value;
        fetch(global.config.server_path + 'mockup/get_mockups/', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            'credentials': 'include',
            body: JSON.stringify(payload)
        })
            .then(resp => resp.json())
            .then(resp => {
                let results = resp.data.map( x => ({ ...x, thumbnail: x.placeholders[0] || x.tracing_image_src }));
                this.setState({
                    data: this.state.data.concat(results),
                    page: this.state.page + 1
                })
            })
            .catch(err => console.log(err))
    };


    fetchData = () => {
        if (this.state.searchActive) {
            this.fetchSearchResults();
        } else {
            this.fetchTemplates();
        }
    };

    handleSearchClear = () => {
        this.setState({
            data: [],
            searchActive: false,
            searchKeywords: '',
            page: 1
        }, this.fetchData)
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        this.setState({
            data: [],
            searchActive: true,
            page: 1
        }, this.fetchData)
    };

    render() {
        return (
            <React.Fragment>
                <div className="nav_content_search_container" style={{padding: 12, paddingTop: 20}}>
                    <Form onSubmit={this.handleSearchSubmit}>
                        <FormGroup>
                            <InputGroup style={{width: "100%"}}>
                                <FormControl
                                    style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 4}}
                                    placeholder={'Search templates'}
                                    value={this.state.searchKeywords}
                                    type="text"
                                    onChange={(e) => this.handleSearchOnChange(e)}
                                />
                                {this.state.searchActive ?
                                    (<span onClick={this.handleSearchClear} style={{
                                        cursor: 'pointer',
                                        position: 'absolute',
                                        right: 12,
                                        top: 9,
                                        fontSize: 22,
                                        zIndex: 100,
                                        color: '#C8CDD4'
                                    }} className="fas fa-times fa-2x fas-light"/>)
                                    : (<span onClick={this.handleSearchSubmit} style={{
                                        position: 'absolute',
                                        cursor: 'pointer',
                                        right: 12,
                                        top: 9,
                                        fontSize: 22,
                                        zIndex: 100,
                                        color: '#C8CDD4'
                                    }} className="fas fa-search fa-2x fas-light"/>)
                                }
                            </InputGroup>
                            <Button style={{'display': 'none'}} type='submit'/>
                        </FormGroup>
                    </Form>
                </div>

                <Select
                    styles={categorySelectionStyles}
                    className="template_category_select"
                    label="Design Template Category Select"
                    options={this.state.categories}
                    placeholder="Select Category"
                    value={this.state.selectedCategory}
                    onChange={((e) => {
                        this.handleCategoryChange(e)
                    })}
                />

                <InfiniteScroll
                    dataLength={this.state.data ? this.state.data.length : 0}
                    next={this.fetchData}
                    hasMore={true}
                    height={'calc(100vh - 198px)'}
                    endMessage={<h4>No more results.</h4>}
                >
                    <DesignResourcesPanel
                        on_drag_start={this.props.on_drag_start}
                        on_drag={this.props.on_drag}
                        on_drag_end={this.props.on_drag_end}
                        on_click={this.props.on_click}
                        image_height={'126px'}
                        col_size={6}
                        resources={this.state.data.map(x => ({
                            src: x.thumbnail,
                            mockup_id: x._id,
                            inputs: {
                                hue_values:[],
                                user_images: []
                            }
                        }))}
                    />
                </InfiniteScroll>

            </React.Fragment>
        );
    }
}

export default MockupPanel;